<div class="p-0" *ngIf="canSetAdditionalSteps">
  <form *ngIf="form" [formGroup]="form" class="mb-10">
    <div class="row">
      <div class="col-4 pr-0">
        <mat-form-field class="mat-form-field-fluid" appearance="outline">
          <mat-label>Additional Step</mat-label>
          <mat-select formControlName="additional_step" placeholder="Additional Step" required>
            <mat-option *ngFor="let step of additionalSteps" [value]="step">
              {{ step.task_template?.name }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="form.controls['additional_step'].hasError('required')"
            style="margin-top: 15px"
          >
            Additional Step field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-4 pr-0">
        <kt-general-autocomplete
          [appearance]="'outline'"
          [label]="'Action'"
          [loadItemsFunction]="actionAutocompleteCall"
          [optionFormatter]="filterActionFn"
          [valueFormatter]="filterActionFn"
          [control]="form.get('action')"
          [change]="onActionChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Action'"
          #actionAutocomplete
          [required]="true"
          [readOnly]="mode === 'view'"
        >
        </kt-general-autocomplete>
      </div>
      <div class="col-2">
        <button (click)="goMapping()" class="btn btn-light-success" [disabled]="mode === 'view'">
          <i class="flaticon-map"></i> Mapping</button
        ><br />
        <small class="text-muted" *ngIf="!mappingError">Change your mapping from here.</small>
        <small class="text-danger" *ngIf="mappingError">Mapping is required.</small>
      </div>
    </div>

    <div class="d-flex align-items-end justify-content-between mt-4">
      <div class="d-flex align-items-center">
        <button
          *ngIf="index"
          mat-raised-button
          class="btn btn-light mt-4 mr-4"
          (click)="cancelUpdateAction($event)"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          class="btn btn-primary mt-4"
          (click)="addTaskAction($event)"
          [disabled]="mode === 'view'"
        >
          {{ updateTaskActionsMode ? 'Update' : 'Create' }} Task Action
        </button>
      </div>
    </div>
  </form>
  <div class="border rounded p-4">
    <div *ngIf="!mappedActions?.length" class="font-weight-bold text-center w-100">
      There are no steps added!
    </div>
    <ng-container *ngIf="mappedActions?.length">
      <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
        <div class="col-5">Additional Step</div>
        <div class="col-5">Action</div>
        <div class="col-2">Actions</div>
      </div>
      <div>
        <div
          *ngFor="let action of mappedActions; let idx = index"
          class="row border-bottom m-0 mb-2 p-2 w-100"
        >
          <div class="col-5">{{ action?.additional_step_template?.task_template?.name }}</div>
          <div class="col-5">{{ action?.action?.name }}</div>
          <div class="col-2" *ngIf="mode !== 'view'">
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
              [matTooltip]="'TABLE.UPDATE' | translate"
              (click)="updateTaskAction(action)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-danger"
              [matTooltip]="'TABLE.DELETE' | translate"
              (click)="deleteTaskAction(action.id)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div
  class="alert alert-custom alert-outline-2x alert-outline-danger fade show mb-5"
  role="alert"
  *ngIf="!canSetAdditionalSteps"
  style="width: 100%"
>
  <div class="alert-icon"><i class="flaticon-warning"></i></div>
  <div class="alert-text">
    This template is a step of another one, so you can't include task actions in it, Or it might be
    an intervention task template.
  </div>
</div>

